var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "internal-fee-markup-rule",
      staticStyle: {
        height: "100%",
        display: "flex",
        "flex-direction": "column"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cargo-advance-search",
          staticStyle: {
            width: "100%",
            "margin-top": "5px",
            "min-width": "1280px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "left",
                    "label-width": "65px",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: { gutter: 10 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_FeeName") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ChargeItem,
                                  clearable: "",
                                  filterable: "",
                                  "default-value": _vm.filter.feeItemId
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.filter.feeName = p.tagName
                                    _vm.filter.feeItemId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Status"),
                                "label-width": "45px"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.filter.enabled,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "enabled", $$v)
                                    },
                                    expression: "filter.enabled"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_AllStatus"),
                                      value: "all"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Enabled"),
                                      value: "1"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Disabled"),
                                      value: "0"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "left" },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.toQuery }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "default" },
                              on: { click: _vm.toReset }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.toAdd }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddRule")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.toBatchDelete }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_BatchDelete"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "grid-view",
          staticStyle: {
            "flex-grow": "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            { staticClass: "main-content", staticStyle: { "flex-grow": "1" } },
            [
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "261701",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        this$1.gridApi = params.api
                      },
                      "selection-changed": _vm.onSelectionChanged
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "261701",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.isView
              ? _vm.$t("CargoMsg.Cargo_Details")
              : _vm.dialog.isEdit
              ? _vm.$t("CargoMsg.Cargo_EditRule")
              : _vm.$t("CargoMsg.Cargo_AddRule"),
            visible: _vm.dialog.visible,
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": "",
            "custom-class": "internal-fee-markup-rule-dialog"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.dialog.form,
                "label-width": "120px",
                rules: _vm.dialog.rules,
                disabled: _vm.dialog.isView
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_FeeName"),
                    prop: "feeName"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    ref: "dialogFeeSelect",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_ChargeItem,
                      clearable: "",
                      filterable: "",
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("CargoMsg.Cargo_FeeName"),
                      "default-value": _vm.dialog.form.feeItemId
                    },
                    on: { parentCallBack: _vm.onFeeNameChange }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_IncomeExpenseType"),
                    prop: "incomeExpenseType"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.dialog.form.incomeExpenseType,
                        callback: function($$v) {
                          _vm.$set(_vm.dialog.form, "incomeExpenseType", $$v)
                        },
                        expression: "dialog.form.incomeExpenseType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_Receivable"),
                          value: "AR"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_AccountsPayable"),
                          value: "AP"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_MarkupType"),
                    prop: "markupType"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleMarkupTypeChange },
                      model: {
                        value: _vm.dialog.form.markupType,
                        callback: function($$v) {
                          _vm.$set(_vm.dialog.form, "markupType", $$v)
                        },
                        expression: "dialog.form.markupType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "FIXED" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FixedAmount")))
                      ]),
                      _c("el-radio", { attrs: { label: "PERCENT" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PercentMarkup")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_MarkupValue"),
                    prop: "markupValue"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.markupValuePlaceholder },
                    on: {
                      input: _vm.handleMarkupValueInput,
                      blur: _vm.onMarkupValueBlur
                    },
                    model: {
                      value: _vm.dialog.form.markupValue,
                      callback: function($$v) {
                        _vm.$set(_vm.dialog.form, "markupValue", $$v)
                      },
                      expression: "dialog.form.markupValue"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_ApplicableCompany") }
                },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom-start",
                        width: "400",
                        trigger: "click",
                        "popper-class": "company-tree-popper"
                      },
                      model: {
                        value: _vm.companyPopoverVisible,
                        callback: function($$v) {
                          _vm.companyPopoverVisible = $$v
                        },
                        expression: "companyPopoverVisible"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "company-tree-wrapper",
                          staticStyle: {
                            "max-height": "280px",
                            "overflow-y": "auto"
                          }
                        },
                        [
                          _c("el-tree", {
                            ref: "companyTree",
                            attrs: {
                              data: _vm.officeTreeOptions,
                              "node-key": "value",
                              "default-expanded-keys": _vm.expandedKeys,
                              "render-content": _vm.renderCompanyNode
                            },
                            on: { "node-click": _vm.onCompanyNodeClick }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "company-select-trigger",
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.selectedCompanyLabels,
                              readonly: "",
                              "suffix-icon": "el-icon-arrow-down",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseSelect") +
                                _vm.$t("CargoMsg.Cargo_ApplicableCompany")
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_EnabledStatus") } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.dialog.form.enabledBool,
                        callback: function($$v) {
                          _vm.$set(_vm.dialog.form, "enabledBool", $$v)
                        },
                        expression: "dialog.form.enabledBool"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Enable")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.dialog.isView,
                      expression: "!dialog.isView"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.onSave }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }